import { IApplicationState } from '../../types/redux';
import { INewbuildingsComparison } from '../../types/newbuildingsCompare';

export function selectNewbuildingsComparison(state: IApplicationState): INewbuildingsComparison | null {
  return state.newbuildingsComparison;
}
